<template>
  <span class="pay-range-readiness-amounts" :class="`pay-range-readiness-amounts--${size}`">
    <template v-for="(amount, index) in amounts">
      <span
        v-if="index > 0"
        :key="`sep-${amount.key}`"
        class="pay-range-readiness-amounts__sep"
        aria-hidden="true"
        >-</span
      >
      <span
        :key="amount.key"
        class="pay-range-readiness-amounts__amount"
        :data-anchor="amount.key"
        >{{ amount.value }}</span
      >
    </template>
  </span>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  min: { type: [String, Number], default: "" },
  at50: { type: [String, Number], default: "" },
  at100: { type: [String, Number], default: "" },
  max: { type: [String, Number], default: "" },
  size: {
    type: String,
    default: "md",
    validator: (value) => ["md", "sm"].includes(value),
  },
});

const amounts = computed(() => [
  { key: "0", value: props.min },
  { key: "50", value: props.at50 },
  { key: "100", value: props.at100 },
  { key: "150", value: props.max },
]);
</script>

<style scoped>
.pay-range-readiness-amounts {
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;
  font-family: Inter, sans-serif;
  font-weight: 500;
  white-space: nowrap;
}

.pay-range-readiness-amounts--md {
  gap: 6px;
  font-size: 14px;
  line-height: 20px;
}

.pay-range-readiness-amounts--sm {
  gap: 5px;
  font-size: 12px;
  line-height: 18px;
}

.pay-range-readiness-amounts__amount {
  flex-shrink: 0;
  color: var(--colors-text-text-secondary-700, #344054);
}

.pay-range-readiness-amounts__sep {
  flex-shrink: 0;
  color: var(--colors-text-text-tertiary-600, #475467);
}
</style>
